import React from 'react';
import { CircularProgress, SxProps } from '@mui/material';
import Typography from '@mui/material/Typography';
import { Row } from './Row/Row';

type Props = {
  size?: number;
  message?: string;
  sx?: SxProps;
  loading?: boolean;
};

export const LoadingIndicator = ({ size, message, sx, loading = true }: Props) =>
  !loading ? null : (
    <Row sx={sx} gap={2}>
      <CircularProgress size={size} />
      {message ? <Typography variant='inherit'>{message}</Typography> : null}
    </Row>
  );
